import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";
import SubCategoryContainer from "../../Components/SubCategory/SubCategoryContainer";
import SubCategoryHook from "../../hook/category/SubCategoryHook";
import { useParams } from "react-router-dom";

const SubCategoryPage = () => {
  const { id } = useParams();

  const [category, loading, loadingSpinner, colors, parentCategory] = SubCategoryHook(id);

  const [waitTime, setWaitTime] = useState(true);

  setTimeout(() => {
    setWaitTime(false);
  }, 1500);
  
  return (
    <Col md="12" sm="4">
      {loading === true || loadingSpinner ? (
        <LoadingSpinner />
      ) : (
        <>
          <div style={{ display: waitTime == true ? 'block' : 'none' }}>
            <LoadingSpinner />
          </div>
          <div style={{ display: waitTime == true ? 'none' : 'block' }}>
            <SubCategoryContainer category={category} loading={loading} parentCategory={parentCategory} />
          </div>
        </>
      )}
    </Col>
  );
};

export default SubCategoryPage;
